export enum ContractedRollingGridField {
  opportunityName = "opportunityName",
  projectName = "projectName",
  teamSymbol = "teamSymbol",
  employeeName = "employeeName",
  isVisible = "isVisible",
  confidenceSymbol = "confidenceSymbol",
  year = "year",
}
